export default {"src":"/_next/static/media/smile_white.112f42c9.svg","height":18,"width":18,"blurWidth":0,"blurHeight":0};